import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { alpha } from '@mui/material/styles';
import AppNavbar from './components/AppNavbar.tsx';
import SideMenu from './components/SideMenu.tsx';
import AppTheme from './theme/AppTheme.tsx';
import { Outlet } from 'react-router-dom';

export default function Dashboard(props: { disableCustomTheme?: boolean }) {  

  return (
    <AppTheme {...props} >
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />   

        {/* Main Content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Outlet /> 
            {/* <MainGrid />  */}
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}